"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerSuscripcion = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var classnames_1 = require("classnames");
//import imgAnuncio from "./img-anuncio.JPG";
var url_js_1 = require("../variables/url.js");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var enlace = localBack + 'api/Catalog/receptor';
var filtroSus = localBack + 'api/catalog/receptor/suscripcion/';
var preferencias = localBack + 'api/Catalog/preferencias/';
var unidad = localBack + 'api/Catalog/Unidad';
var categoria = localBack + 'api/Catalog/Categorias';
var VerSuscripcion = /** @class */ (function (_super) {
    __extends(VerSuscripcion, _super);
    function VerSuscripcion(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (event) {
            if (event.charCode === 13 && _this.state.buscar !== "") {
                //console.log('enter press here! ');
                //console.log("Buscar", this.state.buscar);
                var active = _this.state.activeTab;
                /*console.log("Active", this.state.activeTab);*/
                _this.cambiarTap(active.toString(), _this.state.buscar);
            }
        };
        _this.cambiarTap = function (idUnidad, name) {
            var call = "";
            if (idUnidad == "") {
                /*console.log("error Id");*/
            }
            else if (idUnidad == "0") {
                if (name != null) {
                    call = filtroSus + "search" + "/" + name;
                }
                else {
                    call = filtroSus;
                    _this.setState({ buscar: "" });
                }
                fetch(call, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    _this.setState({ dtoList: data });
                });
            }
            else {
                if (name != null) {
                    call = filtroSus + idUnidad + "/search" + "/" + name;
                }
                else {
                    call = filtroSus + idUnidad;
                    _this.setState({ buscar: "" });
                }
                fetch(call, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    _this.setState({ dtoList: data });
                });
            }
        };
        _this.cambiarPagina = function (page) {
            if (page != null)
                fetch(page, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (dataP) {
                    _this.setState({ dtoList: dataP });
                });
        };
        _this.state = {
            activeTab: 0,
            dtoList: { pageNumber: 0, pageSize: 0, firstPage: "", lastPage: "", totalPages: 0, totalRecords: 0, nextPage: "", previousPage: "", data: [], succeeded: false, errors: "", message: "" },
            loading: true, login: false, status: 0, buscar: '', categoriaList: [], unidadList: [], categoriaCheck: [], unidadCheck: []
        };
        /*console.log('alola');*/
        fetch(categoria)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        fetch(unidad)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ unidadList: data });
        });
        fetch(preferencias, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
        })
            .then(function (response) {
            _this.setState({ status: response.status });
            return response.json();
        })
            .then(function (data) {
            _this.setState({ loading: false, unidadCheck: data["unidad"], categoriaCheck: data["categoria"] });
            //console.log(data)
            //console.log("Unidad", this.state.unidadCheck);
            //console.log("Categoria", this.state.categoriaCheck);                
        });
        if (!espolAds_1.checkCookie('token')) {
            fetch(filtroSus, {
                method: 'GET',
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                /*console.log("dtoList", data);*/
                _this.setState({ dtoList: data, loading: false, login: false });
            });
        }
        else {
            fetch(filtroSus, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                /*console.log("dtoList", data);*/
                _this.setState({ dtoList: data, loading: false, login: true });
            });
        }
        // This binding is necessary to make "this" work in the callback  
        _this.handleCancel = _this.handleCancel.bind(_this);
        //this.handleInputChange = this.handleInputChange.bind(this);
        _this.handleCheckChange = _this.handleCheckChange.bind(_this);
        _this.handleCheckChangeCat = _this.handleCheckChangeCat.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }
    //Controlador de tab superior
    VerSuscripcion.prototype.toggle = function (tab) {
        if (this.state.activeTab !== tab)
            this.setState({ activeTab: tab });
    };
    VerSuscripcion.prototype.handleSearch = function (event) {
        this.setState({ buscar: event.target.value });
        /*console.log(this.state.buscar);*/
    };
    VerSuscripcion.prototype.handleCheckChange = function (evnt) {
        var target = evnt.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var cd = this.state.unidadCheck;
        if (value) {
            if (!cd.includes(name)) {
                cd.push(name);
            }
        }
        else {
            var n = cd.indexOf(name);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        this.setState({ unidadCheck: cd });
        /*console.log(this.state.unidadCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    VerSuscripcion.prototype.handleCheck = function (id, check) {
        var cd = this.state.unidadCheck;
        if (check) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        this.setState({ unidadCheck: cd });
        /*console.log(this.state.unidadCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    VerSuscripcion.prototype.handleEdit = function (id) {
        this.props.history.push("/ver-anuncio/" + id);
    };
    VerSuscripcion.prototype.handleCheckChangeCat = function (evnt) {
        var target = evnt.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var cd = this.state.categoriaCheck;
        if (value) {
            if (!cd.includes(name)) {
                cd.push(name);
            }
        }
        else {
            var n = cd.indexOf(name);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        this.setState({ categoriaCheck: cd });
        /*console.log(this.state.categoriaCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    VerSuscripcion.prototype.handleCheckCat = function (id, check) {
        var cd = this.state.categoriaCheck;
        if (check) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        this.setState({ categoriaCheck: cd });
        /*console.log(this.state.categoriaCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    VerSuscripcion.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    VerSuscripcion.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderCreateForm(this.state.categoriaList, this.state.unidadList, this.state.dtoList);
        /*let edit = this.state.editando*/
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "MIS SUSCRIPCIONES")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    VerSuscripcion.prototype.refreshPage = function () {
        window.location.reload(false);
    };
    // This will handle Cancel button click event.  
    VerSuscripcion.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.history.push("/general/principal");
    };
    // Returns the HTML Form to the render() method.  
    VerSuscripcion.prototype.renderCreateForm = function (categoriaList, unidadList, page) {
        var _this = this;
        var uniNames = [];
        var listCod = this.state.unidadCheck;
        var tabTodos = 0;
        this.state.unidadList.map(function (uni) {
            /*console.log(uni.idUnidad, uni.txNombreUnidad);*/
            if (listCod.includes(uni.idUnidad.toString())) {
                uniNames.push([uni.idUnidad, uni.txNombreUnidad]);
            }
        });
        /* if (uniNames.length > 0) {*/
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardBody, { className: "main-content" },
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.Nav, { pills: true },
                                    React.createElement(reactstrap_1.NavItem, { id: tabTodos },
                                        React.createElement(reactstrap_1.NavLink, { className: classnames_1.default({ active: this.state.activeTab === tabTodos }), onClick: function () { _this.toggle(tabTodos); _this.cambiarTap(tabTodos.toString(), null); } }, "Todos")),
                                    uniNames.map(function (unidad) { return (React.createElement(reactstrap_1.NavItem, { id: unidad[0] },
                                        React.createElement(reactstrap_1.NavLink, { className: classnames_1.default({ active: _this.state.activeTab === unidad[0] }), onClick: function () { _this.toggle(unidad[0]); _this.cambiarTap(unidad[0], null); } }, unidad[1]))); })),
                                React.createElement(reactstrap_1.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_1.TabPane, { tabId: tabTodos },
                                        React.createElement(reactstrap_1.Row, null,
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement(reactstrap_1.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_1.InputGroupAddon, null,
                                                        React.createElement(reactstrap_1.InputGroupText, { onClick: function (e) { return _this.cambiarTap(tabTodos.toString(), null); } },
                                                            React.createElement("i", { className: "fas fa-redo" }))))),
                                            React.createElement("div", { className: "col-md-3" },
                                                React.createElement(reactstrap_1.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_1.Input, { placeholder: "Buscar...", onChange: this.handleSearch, onKeyPress: this.handleKeyPress, value: this.state.buscar }),
                                                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                                                        React.createElement(reactstrap_1.InputGroupText, { onClick: function (e) { return _this.cambiarTap(tabTodos.toString(), _this.state.buscar); } },
                                                            React.createElement("i", { className: "now-ui-icons ui-1_zoom-bold" }))))),
                                            React.createElement("div", { className: "col-md-5" }),
                                            React.createElement("div", { className: "pagination col-md-3 c-right" },
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(page.firstPage); } }, "\u00AB"),
                                                React.createElement("a", { hidden: page.previousPage == null, onClick: function (pag) { return _this.cambiarPagina(page.previousPage); } }, page.previousPage != null ? page.pageNumber - 1 : "-"),
                                                React.createElement("a", { className: "active" }, page.pageNumber),
                                                React.createElement("a", { hidden: page.nextPage == null, onClick: function (pag) { return _this.cambiarPagina(page.nextPage); } }, page.nextPage != null ? page.pageNumber + 1 : "-"),
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(page.lastPage); } }, "\u00BB"))),
                                        React.createElement("div", { className: "mb-4" }),
                                        React.createElement(reactstrap_1.Row, null,
                                            page.data.map(function (aprovado) {
                                                return React.createElement(reactstrap_1.Col, { sm: "3", className: "mb-4" },
                                                    React.createElement(reactstrap_1.Card, { key: aprovado.idAnuncio, body: true },
                                                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(aprovado.idAnuncio); } },
                                                            React.createElement("img", { src: aprovado.txImagen, alt: "anuncio", className: "imagen1" })),
                                                        React.createElement(reactstrap_1.CardTitle, null, aprovado.txTitulo),
                                                        React.createElement(reactstrap_1.CardText, null,
                                                            aprovado.txTexto.length > 50
                                                                ? React.createElement("div", { className: "mb-2" }, aprovado.txTexto.substring(0, 55) + "...")
                                                                : React.createElement("div", { className: "mb-2" }, "" + aprovado.txTexto.substring(0, 55)),
                                                            React.createElement("div", null, aprovado.bdTipo == 'A' && aprovado.dtPublicacion != null ? aprovado.dtPublicacion.split("T")[0] : aprovado.dtInicio.split("T")[0]))));
                                            }),
                                            page.data.length == 0 ? React.createElement("div", { className: "row col-md-12" },
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", key: "void", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null))),
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", key: "void", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null,
                                                        "No hay Resultados en ",
                                                        React.createElement("strong", null, "Todos")),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null)))) : null))),
                                uniNames.map(function (unidad) { return (React.createElement(reactstrap_1.TabContent, { activeTab: _this.state.activeTab },
                                    React.createElement(reactstrap_1.TabPane, { tabId: unidad[0] },
                                        React.createElement(reactstrap_1.Row, null,
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement(reactstrap_1.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_1.InputGroupAddon, null,
                                                        React.createElement(reactstrap_1.InputGroupText, { onClick: function (e) { return _this.cambiarTap(unidad[0], null); } },
                                                            React.createElement("i", { className: "fas fa-redo" }))))),
                                            React.createElement("div", { className: "col-md-3" },
                                                React.createElement(reactstrap_1.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_1.Input, { placeholder: "Buscar...", onChange: _this.handleSearch, onKeyPress: _this.handleKeyPress, value: _this.state.buscar }),
                                                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                                                        React.createElement(reactstrap_1.InputGroupText, { onClick: function (e) { return _this.cambiarTap(unidad[0], _this.state.buscar); } },
                                                            React.createElement("i", { className: "now-ui-icons ui-1_zoom-bold" }))))),
                                            React.createElement("div", { className: "col-md-5" }),
                                            React.createElement("div", { className: "pagination col-md-3 c-right" },
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(page.firstPage); } }, "\u00AB"),
                                                React.createElement("a", { hidden: page.previousPage == null, onClick: function (pag) { return _this.cambiarPagina(page.previousPage); } }, page.previousPage != null ? page.pageNumber - 1 : "-"),
                                                React.createElement("a", { className: "active" }, page.pageNumber),
                                                React.createElement("a", { hidden: page.nextPage == null, onClick: function (pag) { return _this.cambiarPagina(page.nextPage); } }, page.nextPage != null ? page.pageNumber + 1 : "-"),
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(page.lastPage); } }, "\u00BB"))),
                                        React.createElement("div", { className: "mb-4" }),
                                        React.createElement(reactstrap_1.Row, null,
                                            page.data.map(function (aprovado) {
                                                return React.createElement(reactstrap_1.Col, { sm: "3", className: "mb-4" },
                                                    React.createElement(reactstrap_1.Card, { key: aprovado.idAnuncio, body: true },
                                                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(aprovado.idAnuncio); } },
                                                            React.createElement("img", { src: aprovado.txImagen, alt: "anuncio", className: "imagen1" })),
                                                        React.createElement(reactstrap_1.CardTitle, null, aprovado.txTitulo),
                                                        React.createElement(reactstrap_1.CardText, null,
                                                            aprovado.txTexto.length > 50
                                                                ? React.createElement("div", { className: "mb-2" }, aprovado.txTexto.substring(0, 55) + "...")
                                                                : React.createElement("div", { className: "mb-2" }, "" + aprovado.txTexto.substring(0, 55)),
                                                            React.createElement("div", null, aprovado.bdTipo == 'A' && aprovado.dtPublicacion != null ? aprovado.dtPublicacion.split("T")[0] : aprovado.dtInicio.split("T")[0]))));
                                            }),
                                            page.data.length == 0 ? React.createElement("div", { className: "row col-md-12" },
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", key: "void", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null))),
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", key: "void", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null,
                                                        "No hay Resultados ",
                                                        React.createElement("strong", null, unidad[1])),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null)))) : null)))); }))))))));
        //}      
    };
    return VerSuscripcion;
}(React.Component));
exports.VerSuscripcion = VerSuscripcion;
//# sourceMappingURL=VerSuscripciones.js.map